<template>
    <div class="header-container">
        <div class="centered">
            <h1 class="pointer" @click="commonJumpHome"></h1>
            <router-link class="navigator" to="/project" v-if="userInfo.user_type == 1 || userInfo.user_type == 3">我的项目</router-link>
            <router-link class="navigator" v-if="userInfo.user_type == 1" :to="{name: 'Talents'}">人才库</router-link>
            <router-link class="navigator" v-if="userInfo.user_type == 1" to="/conversion">转化跟踪</router-link>
            <router-link class="navigator" v-if="userInfo.user_type == 1" to="/landing">我的落地页</router-link>
            <div class="user-wrapper" v-if="userInfo.user_type == 1 || userInfo.user_type == 3">
                <span class="user-head" :style="'background-image: url('+userInfo.header+')'"></span>
                <span class="username">{{userInfo.nick_name}}</span>
                <el-button type="text" @click="fnLogout">退出</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    export default {
        data() {
            return {
                scrollX: 0,     // 水平滚动距离，用于fixed定位的导航条left值
                checkMesTimer: null,
                isLogin: false,
                newUserAlertFlag: false
            };
        },
        computed: {
            ...mapState({
                userInfo: state => state.userInfo.userInfo,
            }),
        },
        created() {
            let _this = this;
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            fnLogout() {
                this.$post('/User/loginOut', {}, (resp) => {
                    if (resp.code == 1) {
                        if (this.userInfo.user_type == 3) {
                            if(location.host.indexOf('zsdx.cn')>=0){
                                location.href = 'http://www.zsdx.cn/dispatch';
                            }else{
                                location.href = 'http://gt.wxhand.com/dispatch';
                            }
                        } else {
                            this.$router.replace({ name: 'Login' });
                        }
                        this.$store.commit('SET_LOG_OUT');

                    } else {
                        this.$message({
                            type: 'warning',
                            message: resp.msg,
                            center: true
                        });
                    }
                });
            },
            /**
             * 垂直滚动时，判断导航条是否fixed定位
             */
            handleScroll(e) {
                this.scrollX = -window.scrollX;
                if (this.fixedFlag && window.scrollY <= 81) {
                    this.fixedFlag = false;
                } else if (!this.fixedFlag && window.scrollY > 81) {
                    this.fixedFlag = true;
                }
            }
        },
        beforeDestroy() {
            if (this.checkMesTimer) {
                clearInterval(this.checkMesTimer);
            }
        }
    };
</script>

<style lang="less" scoped>
    .header-container {
      position: relative;
      margin-bottom: 20px;
      background-color: #fff;
    }

    .centered {
      width: 1180px;
      height: 60px;
      margin: 0 auto;
      background-color: #fff;

      &::before {
        content: "";
        display: table;
      }
    }

    h1 {
      display: inline-block;
      width: 231px;
      height: 34px;
      margin: 13px 137px 13px 0;
      background: url(http://cdn.wxhand.com/amb/images/logo_new.png?v=1.1) center center
        no-repeat;
      background-size: 100% 100%;
      vertical-align: middle;
    }

    .navigator {
      display: inline-block;
      line-height: 60px;
      color: #2d2f33;

      &.router-link-active {
        color: #20a0ff;
      }

      & + .navigator {
        margin-left: 40px;
      }
    }

    .user-wrapper {
      float: right;
      padding: 11px 0;
      vertical-align: baseline;

      .user-head {
        display: inline-block;
        width: 38px;
        height: 38px;
        background-size: cover;
        background-position: 50%;
        background-position: no-repeat;
        border-radius: 50%;
        vertical-align: middle;
      }

      .username {
        display: inline-block;
        margin: 0 10px;
        font-size: 13px;
        color: #5a5e66;
        // line-height: 38px;
      }

      .logout {
        display: inline-block;
        font-size: 13px;
        color: #20a0ff;
        // line-height: 38px;
      }
    }

    .fixed-container {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      min-width: 1180px;
      height: 64px;
      background-color: #fff;
      border-bottom: 1px solid #e0e6ed;
      box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.15);
      z-index: 2000;
    }
</style>


// WEBPACK FOOTER //
// src/components/header/header.vue